import { styled, Typography, TypographyProps } from '@mui/material';
import React from 'react';

export type ModalTitleProps = Omit<TypographyProps, 'variant'>;

const ModalTitleBase: React.FC<ModalTitleProps> = (props) => <Typography {...props} variant={'h3'} />;

ModalTitleBase.defaultProps = {
  gutterBottom: true,
};

export const ModalTitle = styled(ModalTitleBase)<ModalTitleProps>((props) => ({
  '&&': {
    marginTop: '0px',
    fontSize: '20px',
    lineHeight: '30px',
    marginBottom: props.gutterBottom ? '1rem' : 'inherit',
  },
}));
